import ButtonCheckboxList from "components/Common/ButtonCheckboxList"
import ButtonTooltip from "components/Common/ButtonTooltip"
import ThemeModal from "components/Common/ThemeModal"
import { useFilteredVehicleOptions } from "hooks/stockFilterHook"
import { useEditVehicleStock } from "hooks/stockHook"
import React, { useCallback, useEffect, useState, useMemo } from "react"
import { Button } from "reactstrap"

const PublishableOnSocialPlatformsUpdate = ({ stockId = null, data = [] }) => {
  const [allPlatforms, setAllPlatforms] = useState([])
  const [selectedPlatforms, setSelectedPlatforms] = useState([])
  const [modal, setModal] = useState(false)

  const toggle = useCallback(() => {
    setModal(prev => !prev)
  }, [])

  const {
    isLoading: optionLoading,
    platforms: platformsData,
    raw: rawData,
  } = useFilteredVehicleOptions()

  // Extract platform IDs once
  const initialPlatformIds = useMemo(() => {
    return Array.isArray(data)
      ? data.map(item => item?.platform?.id).filter(Boolean)
      : []
  }, [data])

  // Combine all platforms only when available
  useEffect(() => {
    if (rawData?.social_platforms?.length) {
      setAllPlatforms(rawData.social_platforms)
    }
  }, [rawData?.social_platforms])

  // Set initial selected platforms only once
  useEffect(() => {
    if (initialPlatformIds.length) {
      setSelectedPlatforms(initialPlatformIds)
    }
  }, [initialPlatformIds])

  const onChange = useCallback(ids => {
    setSelectedPlatforms(ids)
  }, [])

  const { mutateAsync: editStock, isPending: stockEditLoading } =
    useEditVehicleStock()

  const onSubmit = useCallback(async () => {
    try {
      const res = await editStock({
        id: stockId,
        platformIds: selectedPlatforms,
      })

      if (res.success) toggle()
    } catch (error) {
      console.error("Failed to update publishable platforms:", error)
    }
  }, [editStock, stockId, selectedPlatforms, toggle])

  return (
    <>
      <ButtonTooltip
        type="edit"
        onClick={toggle}
        btnId="edit-publishable-platform"
        btnName="Edit Publishable Platform"
      />

      <ThemeModal isOpen={modal} toggle={toggle} title="Edit Publishable Platform">
        <ButtonCheckboxList
          items={allPlatforms}
          selected={selectedPlatforms}
          onChange={onChange}
        />
        <div className="text-end">
          <Button
            color="success"
            className="mt-3"
            type="button"
            onClick={onSubmit}
            disabled={stockEditLoading}
          >
            {stockEditLoading ? "Saving..." : "Save Changes"}
          </Button>
        </div>
      </ThemeModal>
    </>
  )
}

export default React.memo(PublishableOnSocialPlatformsUpdate)
